import types from '@/vuex/autuacao/actions-types'
import documentos from '@/utils/documentos'
import autuacao from '@/utils/autuacao'
import router from '@/router'
import dates from '../../utils/dates'

const actions = {
  [types.EXIBIR_DIALOG_INTERESSADO]: ({ commit }) => {
    commit(types.EXIBIR_DIALOG_INTERESSADO)
  },
  [types.ESCONDER_DIALOG_INTERESSADO]: ({ commit }) => {
    commit(types.ESCONDER_DIALOG_INTERESSADO)
  },
  [types.EXIBIR_DIALOG_ASSUNTO]: ({ commit }) => {
    commit(types.EXIBIR_DIALOG_ASSUNTO)
  },
  [types.ESCONDER_DIALOG_ASSUNTO]: ({ commit }) => {
    commit(types.ESCONDER_DIALOG_ASSUNTO)
  },
  [types.EXIBIR_DIALOG_GLOSSARIO]: ({ commit }) => {
    commit(types.EXIBIR_DIALOG_GLOSSARIO)
  },
  [types.ESCONDER_DIALOG_GLOSSARIO]: ({ commit }) => {
    commit(types.ESCONDER_DIALOG_GLOSSARIO)
  },

  [types.SET_LISTA_INTERESSADOS]: ({ commit }, payload) => {
    commit(types.SET_LISTA_INTERESSADOS, payload)
  },
  [types.SET_LISTA_ASSUNTO]: ({ commit }, payload) => {
    commit(types.SET_LISTA_ASSUNTO, payload)
  },
  [types.SET_LISTA_ASSUNTO_NIVEL_1]: ({ commit }, payload) => {
    commit(types.SET_LISTA_ASSUNTO_NIVEL_1, payload)
  },

  [types.SET_TIPO_DOCUMENTO]: async ({ commit }, payload) => {
    commit(types.SET_TIPO_DOCUMENTO, payload)
  },
  [types.SET_UNIDADE_PROCEDENCIA]: async ({ commit }, payload) => {
    commit(types.SET_UNIDADE_PROCEDENCIA, payload)
  },
  [types.SET_TIPO_INTERESSADO]: async ({ commit }, payload) => {
    commit(types.SET_TIPO_INTERESSADO, payload)
  },
  [types.SET_INTERESSADO]: async ({ commit }, payload) => {
    commit(types.SET_INTERESSADO, payload)
  },
  [types.SET_ASSUNTO]: async ({ commit }, payload) => {
    commit(types.SET_ASSUNTO, payload)
  },
  [types.SET_RESUMO_ASSUNTO]: async ({ commit }, payload) => {
    commit(types.SET_RESUMO_ASSUNTO, payload)
  },
  [types.SET_OBSERVACAO]: async ({ commit }, payload) => {
    commit(types.SET_OBSERVACAO, payload)
  },
  [types.SET_URGENTE]: async ({ commit }, payload) => {
    commit(types.SET_URGENTE, payload)
  },
  [types.SET_MOTIVO_URGENCIA]: async ({ commit }, payload) => {
    commit(types.SET_MOTIVO_URGENCIA, payload)
  },
  [types.SET_DOCUMENTO_ORIGEM]: async ({ commit }, payload) => {
    commit(types.SET_DOCUMENTO_ORIGEM, payload)
  },
  [types.SET_EMITENTE]: async ({ commit }, payload) => {
    commit(types.SET_EMITENTE, payload)
  },
  [types.SET_DATA_DOCUMENTO_ORIGEM]: async ({ commit }, payload) => {
    commit(types.SET_DATA_DOCUMENTO_ORIGEM, payload)
  },
  [types.SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM]: async ({ commit }, payload) => {
    commit(types.SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, payload)
  },
  [types.SET_DOCUMENTO]: async ({ commit }, payload) => {
    commit(types.SET_DOCUMENTO, payload)
  },

  [types.GET_ITENS_GLOSSARIO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, {root: true})
    try {
      commit(types.SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: [] })
      const response = await autuacao.getItensGlossario()
      response.data.forEach(item => {
        item.descricaoAssunto = item.descricaoAssunto && item.descricaoAssunto.split('-').length > 1
          ? item.descricaoAssunto.substring(item.descricaoAssunto.indexOf('-') + 1).trim()
          : item.descricaoAssunto.trim()
      })
      commit(types.SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os itens do vocabulário controlado' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, {root: true})
    }
  },

  [types.GET_LISTA_TIPO_DOCUMENTO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de documento' }, {root: true})
    try {
      const response = await documentos.getTiposDocumentoAutorizados()
      commit(types.SET_LISTA_TIPO_DOCUMENTO, { listaTipoDocumento: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de documento' }, {root: true})
    }
  },

  [types.GET_LISTA_UNIDADE_PROCEDENCIA]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades de procedência' }, {root: true})
    try {
      const response = await autuacao.getListaUnidadesProcedencia(payload.somenteAtivas)
      commit(types.SET_LISTA_UNIDADE_PROCEDENCIA, { listaUnidadesProcedencia: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as unidades de procedência' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades de procedência' }, {root: true})
    }
  },

  [types.GET_LISTA_TIPO_INTERESSADO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de interessado' }, {root: true})
    let idTipoDocumento = payload && payload.idTipoDocumento ? payload.idTipoDocumento : undefined

    try {
      const response = await autuacao.getListaTipoInteressado(idTipoDocumento)
      let lista = []
      response.data.forEach(tipo => {
        lista.push({id: tipo, descricao: tipo.charAt(0) + tipo.slice(1).toLowerCase().split('_').join(' ')})
      })
      commit(types.SET_LISTA_TIPO_INTERESSADO, { listaTiposInteressado: lista })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de interessados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de interessado' }, {root: true})
    }
  },

  [types.GET_DOCUMENTO_AUTUACAO]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando documento' }, {root: true})
    try {
      const response = await documentos.getDocument(payload.idDocumento)
      if (response.data.situacao !== 'EM_CRIACAO' && response.data.estado['2001'] !== 6) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Apenas documentos em criação podem ser editados' }, {root: true})
        router.push({name: 'NovaAutuacao'})
      } else if (response.data.estado['32002'] !== 3 && response.data.estado['32002'] !== 4) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Apenas documentos nato-digitais ou digitalizados podem ser editados' }, {root: true})
        router.push({name: 'NovaAutuacao'})
      } else {
        commit(types.SET_DOCUMENTO, {documento: response.data})
      }
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar dados do documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando dados do documento.' }, {root: true})
    }
  },

  [types.INICIALIZAR_DADOS]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Inicializando autuação' }, {root: true})
    try {
      commit(types.ESCONDER_DIALOG_ASSUNTO)
      commit(types.ESCONDER_DIALOG_INTERESSADO)
      commit(types.ESCONDER_DIALOG_GLOSSARIO)

      commit(types.SET_TIPO_DOCUMENTO, {tipoDocumento: undefined})
      commit(types.SET_UNIDADE_PROCEDENCIA, {unidadeProcedencia: undefined})
      commit(types.SET_TIPO_INTERESSADO, {tipoInteressado: undefined})
      commit(types.SET_INTERESSADO, {interessado: undefined})
      commit(types.SET_ASSUNTO, {assunto: undefined})
      commit(types.SET_RESUMO_ASSUNTO, {resumoAssunto: undefined})

      commit(types.SET_DOCUMENTO_ORIGEM, {documentoOrigem: undefined})
      commit(types.SET_EMITENTE, {emitente: undefined})
      commit(types.SET_DATA_DOCUMENTO_ORIGEM, {dataDocumentoOrigem: undefined})
      commit(types.SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, {dataRecebimentoDocumentoOrigem: undefined})

      await Promise.all([
        dispatch(types.GET_ITENS_GLOSSARIO),
        dispatch(types.GET_LISTA_TIPO_DOCUMENTO),
        dispatch(types.GET_LISTA_UNIDADE_PROCEDENCIA, {somenteAtivas: payload.somenteAtivas})
      ])
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Erro durante a inicialização de dados da autuação: ${error.statusText}` }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Inicializando autuação' }, {root: true})
    }
  },

  [types.GET_LISTA_INTERESSADOS]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessados.' }, {root: true})
    try {
      commit(types.SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: [] })
      const response = await autuacao.getListaEntidadeInteressada(payload.tipoInteressado, payload.tipoBusca, payload.nome, payload.codigo, payload.somenteAtivos)
      commit(types.SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessados.' }, {root: true})
    }
  },

  [types.GET_ASSUNTOS]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos' }, {root: true})
    try {
      const response = await autuacao.getAssuntos(payload.idTipoDocumento)
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os assuntos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos' }, {root: true})
    }
  },

  [types.GET_ASSUNTO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assunto' }, {root: true})
    try {
      const assunto = (await autuacao.getAssunto(payload.idAssunto)).data
      if (payload.idTipoDocumento) {
        const listaAssuntos = (await autuacao.getAssuntos(payload.idTipoDocumento)).data
        if (!listaAssuntos.some(a => a.id === assunto.id)) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Este assunto é inválido para este tipo de documento' }, {root: true})
          return null
        }
      }
      return assunto
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível encontrar o assunto' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assunto' }, {root: true})
    }
  },

  [types.BUSCAR_LISTA_ASSUNTO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos.' }, {root: true})
    try {
      commit(types.SET_ASSUNTO, { assunto: undefined })
      const response = await autuacao.getListaTiposAssunto(payload.idTipoDocumento)

      let listaAssunto = response.data
      listaAssunto.forEach((a) => { a.descricaoComCodigo = a.codigo + ' - ' + a.descricao })

      commit(types.SET_LISTA_ASSUNTO, { listaAssunto: listaAssunto })
      let atribuiveis = []
      response.data.every(assunto => {
        if (assunto.atribuivel) atribuiveis = [...atribuiveis, assunto]
        return atribuiveis.length <= 1
      })
      if (atribuiveis.length === 1) {
        commit(types.SET_ASSUNTO, {assunto: atribuiveis[0]})
      }
    } catch (error) {
      commit(types.SET_LISTA_ASSUNTO, { listaAssunto: [] })
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de assuntos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos.' }, {root: true})
    }
  },

  [types.ENVIAR_AUTUACAO]: async ({ commit }, payload) => {
    if (
        (payload.bodyAutuacao.documentoOrigem && (!payload.bodyAutuacao.dataDocumentoOrigem || !payload.bodyAutuacao.dataRecebimento || !payload.bodyAutuacao.emitente)) ||
        (payload.bodyAutuacao.dataDocumentoOrigem && (!payload.bodyAutuacao.documentoOrigem || !payload.bodyAutuacao.dataRecebimento || !payload.bodyAutuacao.emitente)) ||
        (payload.bodyAutuacao.dataRecebimento && (!payload.bodyAutuacao.documentoOrigem || !payload.bodyAutuacao.dataDocumentoOrigem || !payload.bodyAutuacao.emitente)) ||
        (payload.bodyAutuacao.emitente && (!payload.bodyAutuacao.documentoOrigem || !payload.bodyAutuacao.dataDocumentoOrigem || !payload.bodyAutuacao.dataRecebimento))
      ) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao definir um documento de origem, todos os campos devem ser preenchidos' }, {root: true})
    } else if (payload.urgente && !payload.motivoUrgencia.length) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao definir um documento como urgente, é necessário definir o motivo da urgência' }, {root: true})
    } else {
      const confirmacaoCallback = async () => {
        commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: payload.idDocumento ? 'Alterando documento' : 'Autuando novo documento' }, {root: true})
        try {
          const response = await autuacao.enviarAutuacao(payload.idDocumento, payload.bodyAutuacao)
          router.push({name: 'InformacoesDocumento', params: {documentId: response.data.idDocumento}})
          commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: payload.idDocumento ? 'Edição realizada com sucesso' : 'Autuação enviada com sucesso' }, {root: true})
        } catch (error) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body.message }, {root: true})
          throw error
        } finally {
          commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: payload.idDocumento ? 'Alterando documento' : 'Autuando novo documento' }, {root: true})
        }
      }
      const config = {
        textoPergunta: payload.idDocumento ? 'Alterar o documento?' : 'Criar novo documento?',
        textoConteudo: payload.idDocumento ? 'O documento será alterado de acordo com as novas informações fornecidas e continuará em sua caixa postal.' : 'Um novo documento será criado com base nas informações fornecidas e constará em sua caixa postal, em estado de criação.',
        textoNao: 'Cancelar',
        textoSim: payload.idDocumento ? 'Alterar' : 'Criar',
        confirmacaoCallback: confirmacaoCallback
      }
      commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
    }
  },
  [types.GET_DOCUMENTO_ORIGEM]: async ({ commit }, payload) => {
    commit(types.SET_BUSCANDO_DOCUMENTO_ORIGEM, { buscandoDocumentoOrigem: true })
    try {
      const response = await autuacao.getDocumentoOrigem(payload.numeroDocumento)
      if (response.data.length === 1) {
        commit(types.SET_DOCUMENTO_ORIGEM, { documentoOrigem: response.data[0].numero })
        commit(types.SET_EMITENTE, { emitente: 'UFES' })
        commit(types.SET_DATA_DOCUMENTO_ORIGEM, { dataDocumentoOrigem: dates.APIFormat(response.data[0].dtCriacao) })
        // Data recebimento do Documento de Origem é igual a sua data de criação.
        commit(types.SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, { dataRecebimentoDocumentoOrigem: dates.APIFormat(response.data[0].dtCriacao) })
      } else {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Documento não encontrado ou não é um processo/documento avulso' }, {root: true})
      }
    } catch (error) {
      console.log(error)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar o documento' }, {root: true})
      throw error
    } finally {
      commit(types.SET_BUSCANDO_DOCUMENTO_ORIGEM, { buscandoDocumentoOrigem: false })
    }
  }

}

export default actions
